import { atom, selector } from "recoil";
import _ from "lodash";

import { API, graphqlOperation } from "aws-amplify";
import { selectedUserSchemeAtom } from "./user";
import { tenantAccessibleResourcesSelector } from "./tenant";
import { listDevicesTableState, listDeviceProvisioningsTable } from "../graphql/queries-custom";

export const devicesListAtom = atom({
	key: "devicesListAtom",
	default: null,
});

export const selectedDeviceAtom = atom({
	key: "selectedDeviceAtom",
	default: null,
});

//Open OUT_OF_COMMS events for the selected scheme, keyed by device id. A device absent from the
//map has no open connection-lost event, which is the portal's definition of online.
//CommsSubscriber owns writing to this.
export const deviceCommsStateAtom = atom({
	key: "deviceCommsStateAtom",
	default: {},
});

//A device should only ever have one open connection-lost event, but if the backend leaves two
//behind, the earlier one is the moment the device actually went quiet.
export const buildCommsStateMap = (events) => {
	if (!Array.isArray(events)) return {};

	return events.reduce((acc, event) => {
		const deviceId = event?.deviceId;
		if (!deviceId) return acc;

		const offlineSince = event?.createdAt ?? null;
		const existing = acc[deviceId]?.offlineSince;
		if (existing && offlineSince && existing <= offlineSince) return acc;

		acc[deviceId] = { offlineSince };
		return acc;
	}, {});
};

export const devicesListSelector = selector({
	key: "devicesListSelector",
	get: async ({ get }) => {
		const selectedScheme = get(selectedUserSchemeAtom);
		const { id: schemeId } = selectedScheme;
		const {
			data: {
				deviceByScheme: { items: devicesData },
			},
		} = await API.graphql(
			graphqlOperation(listDevicesTableState, {
				schemeId: schemeId,
			}),
		);

		for (const device of devicesData) {
			device.zoneBreadcrumb = JSON.parse(device.zoneBreadcrumb);
		}

		let filteredDevices = devicesData;
		if (selectedScheme?.role === "TENANT") {
			const { deviceIds } = await get(tenantAccessibleResourcesSelector);
			filteredDevices = devicesData.filter((device) => deviceIds?.includes(device.id));
		}

		// devicesData.map((deviceData) => {
		// 	const alarmGroupsInput = [];
		// 	const alarmGroupsOutput = [];
		// 	deviceData.alarmGroupsInput.items?.map((input) => {
		// 		alarmGroupsInput.push(input.alarmGroup.name);
		// 	});
		// 	deviceData.alarmGroupsOutput.items?.map((output) => {
		// 		alarmGroupsOutput.push(output.alarmGroup.name);
		// 	});
		// 	deviceData.alarmGroupsInputCount = alarmGroupsInput.length;
		// 	deviceData.alarmGroupsOutputCount = alarmGroupsOutput.length;
		// 	deviceData.alarmGroupsInput = _.sortBy(alarmGroupsInput);
		// 	deviceData.alarmGroupsOutput = _.sortBy(alarmGroupsOutput);
		// });

		return filteredDevices;
	},
	set: ({ set }, newValue) => {
		set(devicesListAtom, newValue);
	},
});

export const devicesProvisionListAtom = atom({
	key: "devicesProvisionListAtom",
	default: null,
});

export const devicesProvisionListSelector = selector({
	key: "devicesProvisionListSelector",
	get: async ({ get }) => {
		const { id: schemeId } = get(selectedUserSchemeAtom);
		const {
			data: {
				deviceProvisioningByScheme: { items: devicesData },
			},
		} = await API.graphql(
			graphqlOperation(listDeviceProvisioningsTable, {
				schemeId: schemeId,
				sortDirection: "DESC",
			}),
		);

		devicesData.map((d) => (d.createdAt = new Date(d.createdAt)));

		return devicesData;
	},
	set: ({ set }, newValue) => {
		set(devicesListAtom, newValue);
	},
});
